module.exports = __webpack_public_path__ + "img/info-circle.c1975414.svg";